import React from 'react';

// Spec §14 GlassCard — base white card, optional hover affordance for
// clickable cards (homepage tiles, list items, etc).
const GlassCard = ({ children, hoverable = false, borderClassName = 'border-borderLight', className = '', onClick, ...rest }) => {
  return (
    <div
      onClick={onClick}
      className={[
        'bg-white border rounded-radiusMd shadow-shadowElevated',
        borderClassName,
        hoverable
          ? 'transition-all duration-150 cursor-pointer hover:bg-panelHover hover:border-accent/35'
          : '',
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </div>
  );
};

export default GlassCard;
